import styles from './IconButton.module.scss'

interface IconButtonProps
  extends Pick<
    React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'aria-label' | 'disabled' | 'onClick' | 'type'
  > {
  active?: boolean
  className?: string
  destructive?: boolean
  icon: React.FC<React.SVGProps<SVGSVGElement>>
  small?: boolean
  variant?: 'primary' | 'outlined' | 'tertiary'
}
const IconButton = ({
  active,
  className,
  destructive,
  icon: Icon,
  small = false,
  variant = 'primary',
  ...buttonProps
}: IconButtonProps) => (
  <button
    className={[styles.iconButton, className].join(' ')}
    data-testid="icon-button"
    {...(active ? { active: '' } : {})}
    {...(destructive ? { destructive: '' } : {})}
    {...(small ? { small: '' } : {})}
    {...{ variant }}
    {...buttonProps}
  >
    <Icon />
  </button>
)

export default IconButton
